import React from "react"

import Transfers from './ChainWmsTransferPos'

// Старый роут /chain/external-transfer-summary: тот же экран перемещений, сразу на вкладке «По суммам»
function Index() {
	return <Transfers defaultTab="amounts" />
}

export default Index
